module.exports = __webpack_public_path__ + "img/056-sleet-2.3c9b9faa.svg";